/**
 * Animación de entrada mínima para gráficos Chart.js del dashboard.
 * Solo aplica al crear el gráfico; las actualizaciones usan update('none').
 */
export const CHART_DASHBOARD_ANIMACION_ENTRADA_MS = 300;

export const CHART_DASHBOARD_OPCIONES_ANIMACION_ENTRADA = {
  duration: CHART_DASHBOARD_ANIMACION_ENTRADA_MS,
  easing: 'easeOutCubic' as const
};
